// This file is purely a placeholder for the builtins that cause issues via sanitize-html and postcss. These are imported by vite in a browser context and throw a console warning.
// Maybe in the future we can remove this file but for now this stub is aliased in the vite config.
export default function BuiltinsPlaceholder() {
  return null;
}
